import { useRef, useState, useEffect } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useDispatch, useSelector } from "react-redux";
import MainHeading from "../../../components/comman/MainHeading";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import FilterComponent from "../../../components/comman/FilterComponent";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import SearchSiteSelect from "../../../components/comman/SiteSearchSelect";

export default function Stock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);

  const timeoutId = useRef(null);

  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    PurchaseItemsList: [],
    siteList: [],
    siteId: filterDetails?.siteId ?? null,
    searchQuery: "",
    isLoadingSite: false,
    initialized: false,
  });

  const [isCleared, setIsCleared] = useState(false);

  useEffect(() => {
    if (!pageStates.initialized) {
      GetSiteList(null, null, true);
    }
  }, []);

  useEffect(() => {
    if (!pageStates.initialized) return;
    if (!pageStates.siteId) return;

    GetPurchaseItemsList();
  }, [
    filterDetails.currentPage,
    filterDetails.pageSize,
    filterDetails.sortByDate,
    filterDetails.year,
    filterDetails.siteId,
    pageStates.searchQuery,
    pageStates.siteId,
    pageStates.initialized,
  ]);

  const GetPurchaseItemsList = () => {
    const API =
      apiUrl.get_purchase_item +
      "?" +
      MainFilterHandler({
        ...filterDetails,
        siteId: pageStates.siteId,
        year: "",
        sortByDate: [],
        searchQuery: pageStates.searchQuery,
      });

    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      PurchaseItemsList: [],
    }));

    callApi(API, { method: "GET" }).then((response) => {
      setPageStates((prev) => ({ ...prev, tableLoader: false }));

      if (response?.status) {
        const newData = response.data.map((item) => ({
          ...item,
          ItemName: item.name,
          unit: item.unit,
          ItemHsnCOde: item.hsnCode,
          StockType: item.stockType === 1 ? "Consumable Asset" : "Fixed Asset",
          ApprovedQuantity: item.totalApprovedQuantity || "0",
          ReceivedQuantity: item.totalReceivedQuantity || "0",
          StockOutQuantity: item.totalStockOutQuantity || "0",
          CurrentStock: item.totalCurrentStock || "0",
        }));

        setPageStates((prev) => ({
          ...prev,
          PurchaseItemsList: newData,
        }));

        dispatch(
          updateFiltersStates({
            count: response.data?.pageInfo?.total,
            totalPages: response.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetSiteList = (companyId = null, search = null, autoSelect = false) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? `${apiUrl.get_site}?pageSize=100${
              companyId ? `&companyId=${companyId}` : ""
            }${search ? `&search=${search}` : ""}`
          : `${apiUrl.get_user_site}?pageSize=100${
              companyId ? `&companyId=${companyId}` : ""
            }${search ? `&search=${search}` : ""}`;

      setPageStates((prev) => ({ ...prev, isLoadingSite: true }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({ ...prev, isLoadingSite: false }));

          if (!response?.status) return resolve([]);

          const formatted = response.data?.site?.map((item) => ({
            value: item?.site?.id || item.id,
            label: item?.site?.name || item.name,
          }));

          let chosenSite =
            filterDetails.siteId &&
            formatted.some((x) => x.value == filterDetails.siteId)
              ? filterDetails.siteId
              : formatted?.[0]?.value || null;

          // Update state
          setPageStates((prev) => ({
            ...prev,
            siteList: formatted,
            initialized: true,
            siteId: autoSelect ? chosenSite : prev.siteId,
          }));

          // Auto update filter only if needed
          if (autoSelect && chosenSite) {
            dispatch(updateFiltersStates({ siteId: chosenSite }));
          }

          resolve(formatted);
        })
        .catch(() => {
          setPageStates((prev) => ({ ...prev, isLoadingSite: false }));
          resolve([]);
        });
    });
  };

  const handleSortData = (data, type) => {
    if (type === "site") {
      setPageStates((prev) => ({
        ...prev,
        siteId: data?.siteId,
      }));

      dispatch(updateFiltersStates({ siteId: data?.siteId }));
    }

    if (type === "companyId") {
      GetSiteList(data.companyId);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;

    clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(() => {
      setPageStates((prev) => ({ ...prev, searchQuery: value }));
    }, 500);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.stock_detail + `/${data.id}`, {
      state: {
        ...data,
        siteId: filterDetails.siteId,
        siteName: filterDetails.siteName,
      },
    });
  };

  const sortList = {
    isShow: "allNotshow",
    isClearButton: false,
    autoSiteSelector: () => {
      return (
        <SearchSiteSelect
          style={{ minWidth: "25rem" }}
          value={
            pageStates.siteList?.find((x) => x.value === pageStates.siteId)
              ?.value
          }
          options={pageStates?.siteList}
          onSelect={(val) => {
            setIsCleared(false);
            handleSortData({ siteId: val.value }, "site");
          }}
          onSearch={(input) => {
            // When search is cleared
            if (!input.trim()) {
              setIsCleared(true);

              setPageStates((prev) => ({
                ...prev,
                siteId: null,
                PurchaseItemsList: [],
              }));

              dispatch(updateFiltersStates({ siteId: "" }));

              // IMPORTANT — do NOT auto-select site after clearing
              GetSiteList(null, null, false);
              return;
            }

            // When user types after clearing search
            const autoSelect = !isCleared; // ⬅ KEY FIX

            GetSiteList(null, input, autoSelect);
          }}
          isLoading={pageStates.isLoadingSite}
          placeholder="Select Site"
          showClearButton={false}
        />
      );
    },
  };

  const TableHeading = [
    { value: "ItemName", label: "Item Name" },
    { value: "unit", label: "Unit" },
    { value: "ItemHsnCOde", label: "HSN Code" },
    { value: "StockType", label: "Stock Type" },
    { value: "ApprovedQuantity", label: "PO Qty" },
    { value: "ReceivedQuantity", label: "Stock In Qty" },
    { value: "StockOutQuantity", label: "Stock Out Qty" },
    { value: "CurrentStock", label: "Available Stock" },
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      clickHandler: HandleView,
    },
  ];

  return (
    <>
      <div className="content">
        <MainHeading title="Stock" />

        <div className="card">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              searchPlaceHolder="Search"
              filterArray={sortList}
              handleData={handleSortData}
              pageStates={pageStates}
              hideAllSiteOption={true}
              getSite={GetSiteList}
            />

            {pageStates.siteId ? (
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates.PurchaseItemsList}
                ActionData={ActionData}
                isLoading={pageStates.tableLoader}
                currentPage={filterDetails.currentPage}
                totalPages={filterDetails.totalPages}
                count={filterDetails.count}
                pageSize={filterDetails.pageSize}
                handleChangePageSize={(val) =>
                  dispatch(updateFiltersStates({ pageSize: val, currentPage: 1 }))
                }
                PageChangeHandler={(page) =>
                  dispatch(updateFiltersStates({ currentPage: page }))
                }
              />
            ) : (
              <div className="text-center py-5">
                <h5 className="text-muted fw-normal">Please select a site to view stock data.</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
